module.exports = __webpack_public_path__ + "resources/feature-icon-3-e7b08eb3fdefcca7e2d321af57e1b959.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/feature-icon-3.png
// module id = 79
// module chunks = 0